// import SingleDeliveryOrdersList from './singleDeliveryOrdersList';
import SingleDeliveryOrdersEdit from './singleDeliveryOrdersEdit';
import SingleDeliveryOrdersCreate from './singleDeliveryOrdersCreate';

export default {
    // list: SingleDeliveryOrdersList,
    edit: SingleDeliveryOrdersEdit,
    create: SingleDeliveryOrdersCreate,
};